import React from 'react';
import ReactDOM from 'react-dom/client';
import './root.css';
import Path from './path';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Path />
  </React.StrictMode>
);